import moment from 'moment-timezone'

import { MS, SECONDS } from 'utils/time/millisecond'

export const MOMENT_FORMAT_TIME_PERIOD_DATE = 'YYYY-MM-DD'
export const MOMENT_FORMAT_DATE = 'M/D/YYYY'
export const MOMENT_FORMAT_TIME = 'h:mm A'
export const MOMENT_FORMAT_DATE_TIME = 'M/D/YYYY h:mm A'
export const MOMENT_FORMAT_DAY = 'ddd'
export const MOMENT_FORMAT_MONTH = 'MMM'
export const MOMENT_FORMAT_MONTH_YEAR = 'MMMM YYYY'
export const MOMENT_FORMAT_WEEKDAY_MONTH_DAY_YEAR = 'ddd, MMMM D, YYYY'
export const MOMENT_FORMAT_TIMESTAMP = 'X'

export function formatTimePeriodDate(date?: moment.MomentInput) {
  return moment(date).format(MOMENT_FORMAT_TIME_PERIOD_DATE)
}

export function getFormattedTimezone() {
  const tz = moment.tz.guess()
  return moment().tz(tz).format('z')
}

export function formatDate(date?: moment.MomentInput) {
  return moment(date).format(MOMENT_FORMAT_DATE)
}

export function formatDay(date?: moment.MomentInput) {
  return moment(date).format(MOMENT_FORMAT_DAY)
}

export function formatMonth(date?: moment.MomentInput) {
  return moment(date).format(MOMENT_FORMAT_MONTH)
}

export function formatMonthYear(date?: moment.MomentInput) {
  return moment(date).format(MOMENT_FORMAT_MONTH_YEAR)
}

export function formatWeekdayMonthDayYear(date?: moment.MomentInput) {
  return moment(date).format(MOMENT_FORMAT_WEEKDAY_MONTH_DAY_YEAR)
}

export function formatJSDate(date?: moment.MomentInput) {
  return moment(date).toDate()
}

export function formatTime(date?: moment.MomentInput) {
  return moment(date).format(MOMENT_FORMAT_TIME)
}

export function formatTimestamp(date?: moment.MomentInput) {
  return moment(date).format(MOMENT_FORMAT_TIMESTAMP)
}

export function formatDateTime(date?: moment.MomentInput) {
  return moment(date).format(MOMENT_FORMAT_DATE_TIME)
}

export function formatLocalTime(utcTimeStamp?: moment.MomentInput) {
  return moment.utc(utcTimeStamp).local().format('H:mm')
}

export function getRelativeTimeFromNow(date: Date) {
  // NOTE: Given that we aren't i18l outside of US, we can bake that in here as 'en-us'
  const formatter = new Intl.RelativeTimeFormat('en-us', { numeric: 'auto' })
  const diffInSeconds = (date.getTime() - Date.now()) / MS.seconds

  if (diffInSeconds === 0) return 'Now'

  for (const unit in SECONDS) {
    if (Math.abs(diffInSeconds) >= SECONDS[unit]) {
      const value = Math.round(diffInSeconds / SECONDS[unit])

      return formatter.format(value, unit as Intl.RelativeTimeFormatUnit)
    }
  }
}

export function getDateInLocalTimeZone(
  date?: string | number | Date,
  locale = 'en-US'
) {
  if (!date) return 'Invalid Date'

  return new Date(date).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}
